export const API_BASE_URL = import.meta.env.VITE_KAVITHAI_API_URL || '/api';
